import React, { ReactNode } from "react";
import styled, { css, keyframes } from "styled-components";
import TooltipContent from "@charty/tooltip/serie";
import { content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Tooltip from "@ui-kit/tooltip";
import Infoline from "./gauge";
import { ANIMATION_DELAY, Gauge, MainUnit, SecondaryUnit } from "./model";

interface IProps {
  gauge: Gauge;
  index: number;
  locale: Locale;
  mainUnit: MainUnit;
  secondaryValue: SecondaryUnit;
  width: number;
  maxCount: number;
  total: number;
  style?: any;
  isTooltipDisabled?: boolean;
  showIndex?: boolean;
  showAvatar?: boolean;
  color?: string;
  evolutionTooltip?: React.ReactNode;
  isNarrow?: boolean;
  showTrackWhenSuperNarrow?: boolean;
  animate?: boolean;
  isHideable?: boolean;
  tooltip?: (gauge: Gauge) => ReactNode;
  onClickGauge?: (gauge: Gauge) => void;
}

const appear = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const StyledInfoline = styled(Infoline)<{
  index: number;
  delay: number;
  clickable: boolean;
  animate?: boolean;
  showIndex?: boolean;
}>`
  border-bottom: 1px solid ${(props) => content(props, "tertiary")};
  margin-top: -1px;
  animation: ${(props) =>
    props.animate &&
    css`
      ${appear} ${props.delay}ms ease
    `};
  cursor: ${(props) =>
    props.clickable ? "var(--cursor-magic-wand)" : "default"};
`;

const Component = ({
  gauge,
  index,
  locale,
  mainUnit,
  secondaryValue,
  isTooltipDisabled,
  width,
  maxCount,
  total,
  style,
  showIndex,
  showAvatar,
  color,
  evolutionTooltip,
  isNarrow,
  showTrackWhenSuperNarrow,
  animate,
  isHideable,
  tooltip,
  onClickGauge,
}: IProps) => {
  return (
    <Tooltip
      disabled={isTooltipDisabled}
      tooltip={
        tooltip ? (
          tooltip(gauge)
        ) : (
          <TooltipContent
            label={gauge.label}
            color={color || gauge.color}
            count={gauge.count}
            locale={locale}
            total={total}
            shorten={false}
          />
        )
      }
    >
      <div style={style} onClick={() => !!onClickGauge && onClickGauge(gauge)}>
        <StyledInfoline
          index={index}
          gauge={gauge}
          locale={locale}
          mainUnit={mainUnit}
          showAvatar={showAvatar}
          showIndex={showIndex}
          showTrackWhenSuperNarrow={showTrackWhenSuperNarrow}
          color={color || gauge.color}
          width={width}
          secondaryValue={secondaryValue}
          isHidden={gauge.isHidden}
          isHideable={isHideable}
          maxCount={maxCount}
          total={total}
          delay={index * ANIMATION_DELAY}
          clickable={!!onClickGauge}
          evolutionTooltip={evolutionTooltip}
          isNarrow={isNarrow}
          animate={animate}
        />
      </div>
    </Tooltip>
  );
};

export default Component;
